import {
  api_GlobalToken,
  api_AccessToken,
  flow_get_tokens_global,
  err
} from "../stores/sagas";
import { fork, take, put, join, select, call } from "redux-saga/effects";
import { createAction, createReducer } from "redux-act";

export const get_entries = createAction("get_entries");
export const post_entries = createAction("post_entries");
export const put_entries = createAction("put_entries");
export const delete_entries = createAction("delete_entries");


export const fetchingFalse = createAction("fetchingFalse");
export const loadingFalse = createAction("loadingFalse");
export const loadingDataFalse = createAction("loadingDataFalse");

export const failure_entries = createAction("failure_entries");

export const entries = createReducer(
  {
    [get_entries]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isFetching = true;
      return newState;
    },

    [post_entries]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = true;
      return newState;
    },
    [put_entries]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = true;
      return newState;
    },
    [delete_entries]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = true;
      return newState;
    },
    [fetchingFalse]: (state, payload) => {
      const newState = Object.assign({}, state, { ...payload.data });
      newState.isFetching = false;
      return newState;
    },
    [loadingDataFalse]: (state, payload) => {
      const newState = Object.assign({}, state, { ...payload.data });
      newState.isLoading = false;
      return newState;
    },
    [loadingFalse]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = false;
      return newState;
    },
  },
  {
    isLoading: false,
    isFetching: true,
    entries: [],
  }
);

export function* flow_get_entries() {
  while (true) {
    const { payload } = yield take(get_entries);

    const { data, error } = yield call(
      api_AccessToken,
      `entries`,
      "get",
      payload.data
    );
    if (!error) {
      yield put(fetchingFalse({ data }));
      !payload.page || payload.page();
    } else {
      yield put(fetchingFalse({ error }));
      !payload.toast || payload.toast(err(error));
    }
  }
}


export function* flow_post_entries() {
  while (true) {
    const { payload } = yield take(post_entries);

    const { data, error } = yield call(
      api_AccessToken,
      `entries/${payload.data.entry_id}`,
      "post",
      payload.data
    );
    if (!error) {
      yield put(loadingFalse({ data }));
      yield put(get_entries({data:payload.search}));

      !payload.page || payload.page();
    } else {
      yield put(loadingFalse({ error }));
      !payload.toast || payload.toast(err(error));
    }
  }
}

export function* flow_put_entries() {
  while (true) {
    const { payload } = yield take(put_entries);

    const { data, error } = yield call(
      api_AccessToken,
      `entries/${payload.data.entry_id}`,
      "put",
      payload.data
    );
    if (!error) {
      yield put(loadingFalse({ data }));
      yield put(get_entries({data:payload.search}));

      !payload.page || payload.page();
    } else {
      yield put(loadingFalse({ error }));
      !payload.toast || payload.toast(err(error));
    }
  }
}
export function* flow_delete_entries() {
  while (true) {
    const { payload } = yield take(delete_entries);

    const { data, error } = yield call(
      api_AccessToken,
      `entries/${payload.data.entry_id}`,
      "delete",
      payload.data
    );
    if (!error) {
      yield put(loadingFalse({ data }));
      yield put(get_entries({data:payload.search}));

      !payload.page || payload.page();
    } else {
      yield put(loadingFalse({ error }));
      !payload.toast || payload.toast(err(error));
    }
  }
}